/**
 * @author: chenlv
 * @date: 2025/01/30
 * @description: Tooltip 共享组件和类型
 */

import React from 'react';

/**
 * 环比类型
 */
export type TRatioType = 'up' | 'down' | 'none';

/**
 * 环比值信息
 */
export interface IRatioInfo {
  /** 环比类型：up(上升)、down(下降)、none(无变化) */
  type: TRatioType;
  /** 格式化后的环比值字符串 */
  value: string;
}

/**
 * 环比指示箭头组件
 */
export const RatioArrow: React.FC<IRatioInfo> = ({ type, value }) => {
  if (type === 'none') {
    return <span className="v3-tooltip-ratio v3-tooltip-ratio--none">{value}</span>;
  }
  const arrowClass = type === 'up' ? 'v3-tooltip-ratio-arrow--up' : 'v3-tooltip-ratio-arrow--down';
  return (
    <span className={`v3-tooltip-ratio v3-tooltip-ratio--${type}`}>
      <span className={`v3-tooltip-ratio-arrow ${arrowClass}`} />
      {value}
    </span>
  );
};
